import {
  CustomizedButton,
  CustomizedTypography,
  Stack,
  VStack
} from '@components/Customized';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';
import { PaymentDetailModal } from '@routes/Payment/component';
import { formatDate } from '@utils/formatter';
import { ProgressInfoBottomItemCommonProps } from './types';

interface PurchaseConfirmedProps extends ProgressInfoBottomItemCommonProps {
  purchaseOrder?: CapaQuotationRfqPurchaseOrder;
}

const PurchaseConfirmed: React.FunctionComponent<PurchaseConfirmedProps> = ({
  payment,
  purchaseOrder
}) => {
  if (!payment || !purchaseOrder) return null;

  const confirmedAt = formatDate(payment?.confirmedAt ?? '', 'YYYY.MM.DD');

  return (
    <Stack justifyContent="space-between" alignItems="center">
      <VStack>
        <CustomizedTypography variant="body2" color="textSecondary">
          거래완료일
        </CustomizedTypography>
        <CustomizedTypography variant="body2" color="textPrimary">
          {confirmedAt}
        </CustomizedTypography>
      </VStack>
      <PaymentDetailModal
        paymentData={payment}
        purchaseOrder={purchaseOrder}
        openButton={(onClick) => (
          <CustomizedButton
            variant="contained"
            color="default"
            size="small"
            onClick={onClick}
          >
            <CustomizedTypography
              variant="body2"
              fontWeight="500"
              color="textPrimary"
            >
              거래내역 확인
            </CustomizedTypography>
          </CustomizedButton>
        )}
      />
    </Stack>
  );
};

export default PurchaseConfirmed;
